// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_organization_permissions.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.diagnocat.model.OrganizationPermissions
 */
export const OrganizationPermissions = proto3.makeMessageType(
  "com.diagnocat.model.OrganizationPermissions",
  () => [
    { no: 1, name: "CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "CanEditInfo", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "CanViewSettings", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "CanEditSettings", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "CanViewStaff", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "CanEditStaff", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "CanViewFeatureFlags", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "CanEditFeatureFlags", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "CanCreateTheirOwnPatients", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "CanCreateOtherDoctorsPatients", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "CanViewMyPatients", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "CanViewAllPatients", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "CanManageComment", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "CanViewStatistics", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 31, name: "Billing_CanViewInventory", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 32, name: "Billing_CanViewOrder", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 33, name: "Billing_CanViewAccount", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "Billing_CanEditPaymentMethod", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 35, name: "Billing_CanEditAccountSettings", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 36, name: "Billing_CanEditAccountContacts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 37, name: "Billing_CanEditProducts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 42, name: "APIKey_CanView", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 43, name: "APIKey_CanCreate", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 44, name: "APIKey_CanDelete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 45, name: "MFA_CanEdit", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 46, name: "CanEditType", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 47, name: "Sessions_CanManageStaff", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

